import { commonNewClassnames } from '@common';

const prefix = 'admin';

export const newClassnames = (name) => commonNewClassnames(`${prefix}-${name}`);

export const routerPaths = {
    home: `/${prefix}`,
    studentManagement: `/${prefix}/studentmanagment`,
    groupManagement: `/${prefix}/groupmanagement`,
    groupDetails: `/${prefix}/groupmanagement/groupdetails/:groupName/:id`,
    reporting: `/${prefix}/reporting`,
    emailTemplate: `/${prefix}/emailTemplate`,
    FAQ: `/${prefix}/FAQ`
};